import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item"];
import React from 'react';
import { escapeHighlight } from '../../utils';
import { Highlight } from '../Highlight/Highlight';
import { Row } from './Row';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MapRow(_ref) {
  var item = _ref.item,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var description = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Highlight, {
      text: item.type_localized
    }), ", ", /*#__PURE__*/_jsx(Highlight, {
      text: item.office
    }), ",", ' ', /*#__PURE__*/_jsx(Highlight, {
      text: item.floor
    })]
  });
  return /*#__PURE__*/_jsx(Row, _objectSpread({
    type: item.object_type,
    subtype: escapeHighlight(item.type),
    description: description,
    item: item
  }, otherProps));
}
// #sourceMappingURL=MapRow.js.map